import { render, staticRenderFns } from "./ModalDocumentAdd.vue?vue&type=template&id=624db876"
import script from "./ModalDocumentAdd.vue?vue&type=script&lang=js"
export * from "./ModalDocumentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports